module.exports = __webpack_public_path__ + "static/media/folder.3f5f7e39.svg";